import React from 'react';
const included = ['Catequesis 1 — 40 páginas', 'Catequesis 2 — 45 páginas', 'Confirmación — 35 páginas'];
const extras = ['Actividades listas para imprimir y trabajar.', 'Acceso digital inmediato.', 'Podés volver a descargar los materiales cuando los necesites.'];
export function ValueStackSection() {
  return <section className="py-10 px-4 bg-gray-900 text-white" data-id="element-178" data-mp="1hcypy872k9we">
      <div className="max-w-3xl mx-auto text-center" data-id="element-179" data-mp="tnmgd77txztk">
        <h2 className="text-[20px] md:text-2xl font-black mb-6" data-id="element-180" data-mp="tofg3o8dfp27">
          TODO LO QUE VAS A RECIBIR HOY
        </h2>

        <div className="bg-gray-800 border border-[#157C8B] rounded-3xl p-6 text-left" data-id="element-181" data-mp="oqdvgyvarhom">
          <p className="text-sm font-bold text-gray-400 uppercase tracking-wide mb-3" data-id="element-182" data-mp="12pvpbsng9l4u">
            📦 Acceso inmediato a:
          </p>
          <ul className="space-y-2 mb-4" data-id="element-183" data-mp="2e3hc575u7an7">
            {included.map(item => <li key={item} className="flex items-start text-base font-bold" data-id="element-184" data-mp="2e1o53qrbaoeo">
                <span className="text-[#4FD1DB] mr-2" data-id="element-185" data-mp="2a148coanhmt2">✔</span>
                {item}
              </li>)}
          </ul>

          <p className="text-base font-black text-[#F5CE3E] mb-4" data-id="element-186" data-mp="1ncp2lxv7mzbf">
            🎁 BONUS PREMIUM: ESI para Escuela Católica — 42 páginas
          </p>

          <p className="text-2xl md:text-3xl font-black text-center border-t border-gray-700 pt-4 mb-3" data-id="element-187" data-mp="1wd54j2wb1ye6">
            162 PÁGINAS EN TOTAL
          </p>

          <div className="space-y-1 text-center" data-id="element-188" data-mp="21byggqvy1hc8">
            {extras.map(item => <p key={item} className="text-base text-gray-300" data-id="element-189" data-mp="14nij48mle3ok">
                {item}
              </p>)}
          </div>
        </div>
      </div>
    </section>;
}